export function getFileUrl(file: File) {
  return file ? URL.createObjectURL(file) : ""
}
